<template>
    <v-navigation-drawer
    :value="value"
    app
    absolute
    right
    bottom
    temporary
    stateless
    class="links"
    >

        <template #prepend>
            <div class="ma-5 text-right">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <a 
                            @click="closeDrawer"
                            v-bind="attrs"
                            v-on="on">
                            <feather type="x" class="main--text"/>
                        </a>
                    </template>
                    <span class="mt-n2">Close</span>
                </v-tooltip>
                
            </div>
        </template>
        <v-divider></v-divider>
        <v-list nav>
            <v-list-item-group>
                <div  v-for="(item, index) in menuItems" :key="index" :class="{'mb-2': index === 3}">
                    <v-list-item 
                        :to="item.to"
                        active-class="secondary primary--text"
                        @click="closeDrawer"
                    >
                        <v-list-item-title> {{ item.title }}</v-list-item-title>
                    </v-list-item>
                    <div class="py-3 px-2 my-1 customer-reviews" v-if="index === 2" @click="handleCustomeReviews" role="link">
                        <a 
                            class="main--text" 
                            style="text-decoration: none;"
                        > Customer Reviews </a>
                    </div>
                </div>

                <v-divider class="my-6"></v-divider>

                <v-list-item
                    v-for="service in services" 
                    :key="service.slug"
                    :to="service.path"
                    @click="closeDrawer"
                >
                    <v-list-item-title>{{ service.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item to="/driver" @click="closeDrawer">
                    <v-list-item-title> Service Providers </v-list-item-title>
                </v-list-item>

                <v-divider class="my-6"></v-divider>

                <v-list-item 
                    v-for="item in navItems" 
                    :key="item.title"
                    :href="item.href"
                    :target="item.target"
                    active-class="secondary primary--text"
                    @click="closeDrawer"
                >
                    <v-list-item-title> {{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <!-- <div class="text-center">
            <a 
                href="https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D" 
                target="_blank" 
                style="text-decoration: none;"
                :class="{'mt-2': $vuetify.breakpoint.width > 700}"
                >
                <img src="@/assets/googleReviews.png" width="150" alt="Dash Waste Google reviews"/>
            </a>
        </div> -->
        
    </v-navigation-drawer>
</template>

<script>
import seoContent from '@/content/seo-content';

export default {
    name: "NavigationBar",
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => false,
        }
    },
    data() {
        return {
            services: seoContent.services,
            menuItems: [
                {
                    title: "Home",
                    to: "/"
                },
                {
                    title: "FAQS",
                    to: "/help"
                },
                {
                    title: "About",
                    to: "/about"
                }
            ],
            navItems: [
                {
                    title: "Sign Up",
                    href: "https://app.dashwaste.co.za/signup",
                },
                {
                    title: "Login",
                    href: "https://app.dashwaste.co.za/login"
                }
            ]
        }
    },
    computed: {
        
    },
    methods: {
        closeDrawer() {
            this.$emit("close");
        },
        check() {
            this.$nextTick(() => {
                //this.$refs.menuList[0].$el.classList.remove('v-list-item--active');
            })
        },
        handleCustomeReviews() {
            this.closeDrawer();
            window.open("https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D", "_blank");
        }
    }

}
</script>
<style scoped>
.links {
    font-family: Avenir3;
    font-weight: bold;

}
.customer-reviews {
    cursor: pointer;
}
.customer-reviews:hover {
    background-color: rgb(241, 241, 241);
    border-radius: 5px;
}
</style>
